/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Metadata from './Metadata';

/**
 * The IngestJob model module.
 * @module model/IngestJob
 * @version 1.0.0
 */
class IngestJob {
    /**
     * Constructs a new <code>IngestJob</code>.
     * @alias module:model/IngestJob
     */
    constructor() { 
        
        IngestJob.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IngestJob</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IngestJob} obj Optional instance to populate.
     * @return {module:model/IngestJob} The populated <code>IngestJob</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IngestJob();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('ingestFile')) {
                obj['ingestFile'] = ApiClient.convertToType(data['ingestFile'], 'String');
            }
            if (data.hasOwnProperty('proxyFile')) {
                obj['proxyFile'] = ApiClient.convertToType(data['proxyFile'], 'String');
            }
            if (data.hasOwnProperty('thumbFile')) {
                obj['thumbFile'] = ApiClient.convertToType(data['thumbFile'], 'String');
            }
            if (data.hasOwnProperty('tapeID')) {
                obj['tapeID'] = ApiClient.convertToType(data['tapeID'], 'String');
            }
            if (data.hasOwnProperty('parentTapeId')) {
                obj['parentTapeId'] = ApiClient.convertToType(data['parentTapeId'], ['String']);
            }
            if (data.hasOwnProperty('parentName')) {
                obj['parentName'] = ApiClient.convertToType(data['parentName'], ['String']);
            }
            if (data.hasOwnProperty('groupID')) {
                obj['groupID'] = ApiClient.convertToType(data['groupID'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('tcOffset')) {
                obj['tcOffset'] = ApiClient.convertToType(data['tcOffset'], 'String');
            }
            if (data.hasOwnProperty('codec')) {
                obj['codec'] = ApiClient.convertToType(data['codec'], 'String');
            }
            if (data.hasOwnProperty('width')) {
                obj['width'] = ApiClient.convertToType(data['width'], 'Number');
            }
            if (data.hasOwnProperty('height')) {
                obj['height'] = ApiClient.convertToType(data['height'], 'Number');
            }
            if (data.hasOwnProperty('anamorph')) {
                obj['anamorph'] = ApiClient.convertToType(data['anamorph'], 'Boolean');
            }
            if (data.hasOwnProperty('restricted')) {
                obj['restricted'] = ApiClient.convertToType(data['restricted'], 'Boolean');
            }
            if (data.hasOwnProperty('externalRights')) {
                obj['externalRights'] = ApiClient.convertToType(data['externalRights'], 'Boolean');
            }
            if (data.hasOwnProperty('hidden')) {
                obj['hidden'] = ApiClient.convertToType(data['hidden'], 'Boolean');
            }
            if (data.hasOwnProperty('delete')) {
                obj['delete'] = ApiClient.convertToType(data['delete'], 'Boolean');
            }
            if (data.hasOwnProperty('metadata')) {
                obj['metadata'] = ApiClient.convertToType(data['metadata'], [Metadata]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>IngestJob</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>IngestJob</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }
        // ensure the json data is a string
        if (data['ingestFile'] && !(typeof data['ingestFile'] === 'string' || data['ingestFile'] instanceof String)) {
            throw new Error("Expected the field `ingestFile` to be a primitive type in the JSON string but got " + data['ingestFile']);
        }
        // ensure the json data is a string
        if (data['proxyFile'] && !(typeof data['proxyFile'] === 'string' || data['proxyFile'] instanceof String)) {
            throw new Error("Expected the field `proxyFile` to be a primitive type in the JSON string but got " + data['proxyFile']);
        }
        // ensure the json data is a string
        if (data['thumbFile'] && !(typeof data['thumbFile'] === 'string' || data['thumbFile'] instanceof String)) {
            throw new Error("Expected the field `thumbFile` to be a primitive type in the JSON string but got " + data['thumbFile']);
        }
        // ensure the json data is a string
        if (data['tapeID'] && !(typeof data['tapeID'] === 'string' || data['tapeID'] instanceof String)) {
            throw new Error("Expected the field `tapeID` to be a primitive type in the JSON string but got " + data['tapeID']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['parentTapeId'])) {
            throw new Error("Expected the field `parentTapeId` to be an array in the JSON data but got " + data['parentTapeId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['parentName'])) {
            throw new Error("Expected the field `parentName` to be an array in the JSON data but got " + data['parentName']);
        }
        // ensure the json data is a string
        if (data['groupID'] && !(typeof data['groupID'] === 'string' || data['groupID'] instanceof String)) {
            throw new Error("Expected the field `groupID` to be a primitive type in the JSON string but got " + data['groupID']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['tcOffset'] && !(typeof data['tcOffset'] === 'string' || data['tcOffset'] instanceof String)) {
            throw new Error("Expected the field `tcOffset` to be a primitive type in the JSON string but got " + data['tcOffset']);
        }
        // ensure the json data is a string
        if (data['codec'] && !(typeof data['codec'] === 'string' || data['codec'] instanceof String)) {
            throw new Error("Expected the field `codec` to be a primitive type in the JSON string but got " + data['codec']);
        }
        if (data['metadata']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['metadata'])) {
                throw new Error("Expected the field `metadata` to be an array in the JSON data but got " + data['metadata']);
            }
            // validate the optional field `metadata` (array)
            for (const item of data['metadata']) {
                Metadata.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} id
 */
IngestJob.prototype['id'] = undefined;

/**
 * @member {String} ingestFile
 */
IngestJob.prototype['ingestFile'] = undefined;

/**
 * @member {String} proxyFile
 */
IngestJob.prototype['proxyFile'] = undefined;

/**
 * @member {String} thumbFile
 */
IngestJob.prototype['thumbFile'] = undefined;

/**
 * @member {String} tapeID
 */
IngestJob.prototype['tapeID'] = undefined;

/**
 * @member {Array.<String>} parentTapeId
 */
IngestJob.prototype['parentTapeId'] = undefined;

/**
 * @member {Array.<String>} parentName
 */
IngestJob.prototype['parentName'] = undefined;

/**
 * @member {String} groupID
 */
IngestJob.prototype['groupID'] = undefined;

/**
 * @member {String} title
 */
IngestJob.prototype['title'] = undefined;

/**
 * @member {String} tcOffset
 */
IngestJob.prototype['tcOffset'] = undefined;

/**
 * @member {String} codec
 */
IngestJob.prototype['codec'] = undefined;

/**
 * @member {Number} width
 */
IngestJob.prototype['width'] = undefined;

/**
 * @member {Number} height
 */
IngestJob.prototype['height'] = undefined;

/**
 * @member {Boolean} anamorph
 */
IngestJob.prototype['anamorph'] = undefined;

/**
 * @member {Boolean} restricted
 */
IngestJob.prototype['restricted'] = undefined;

/**
 * @member {Boolean} externalRights
 */
IngestJob.prototype['externalRights'] = undefined;

/**
 * @member {Boolean} hidden
 */
IngestJob.prototype['hidden'] = undefined;

/**
 * @member {Boolean} delete
 */
IngestJob.prototype['delete'] = undefined;

/**
 * @member {Array.<module:model/Metadata>} metadata
 */
IngestJob.prototype['metadata'] = undefined;






export default IngestJob;

